import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconHeart = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--heart")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M12.804018,3.90488483 C14.023092,2.68523838 15.6768548,2 17.4012907,2 C19.1257266,2 20.7794894,2.68523838 21.9985634,3.90488483 C23.2178779,5.12362695 23.9031163,6.77738977 23.9031163,8.50182562 C23.9031163,10.2262615 23.2178779,11.8800243 21.9983975,13.0989324 L13.1583975,21.9389324 C12.7678732,22.3294567 12.1347082,22.3294567 11.7441839,21.9389324 L2.90418391,13.0989324 C0.365272004,10.5600204 0.365272035,6.44363084 2.90418398,3.9047189 C5.44309592,1.36580696 9.55948549,1.36580693 12.0983975,3.90471884 L12.4512907,4.25761207 L12.804018,3.90488483 Z M12.4512907,19.8176121 L19.5241839,12.7447188 L20.5843499,11.6845529 C21.4287205,10.8405785 21.9031163,9.69566583 21.9031163,8.50182562 C21.9031163,7.30798542 21.4287205,6.16307269 20.5843499,5.31909835 C19.7400436,4.4743958 18.5951309,4 17.4012907,4 C16.2074505,4 15.0625378,4.4743958 14.2183975,5.3189324 L13.1583975,6.3789324 C12.7678732,6.76945669 12.1347082,6.76945669 11.7441839,6.3789324 L10.6841839,5.31893241 C8.92632054,3.56106907 6.07626091,3.56106909 4.31839754,5.31893246 C2.56053417,7.07679583 2.56053415,9.92685546 4.31839748,11.6847188 L12.4512907,19.8176121 Z" id="icon--centivo--heart"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1062.000000, -636.000000)"/>
          <g id="Icon/heart">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--heart"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--heart"/>
          </g>
      </g>
  </IconWrapper>
)
